"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeSpan = void 0;
const dateParse_1 = require("./dateParse");
const numberFormatPad_1 = require("./numberFormatPad");
/**
 * klasa reprezentująca różnicę czasu
 *
 * @export
 * @class TimeSpan
 */
class TimeSpan {
    static diff(lateDate, earlyDate) {
        try {
            const dt1 = (0, dateParse_1.dateParse)(lateDate);
            const dt2 = (0, dateParse_1.dateParse)(earlyDate);
            const offset = dt1.getTimezoneOffset() - dt2.getTimezoneOffset(); // zeby pomiedzy datami z czasu zimowego i letniego było dokładnie 24 h
            return new TimeSpan(dt1.getTime() - dt2.getTime() - offset * 60 * 1000, dt1, dt2);
        }
        catch (err) {
            if (process.env.NODE_ENV === 'development') {
                console.error(`[DEBUG] invalid TimeSpan("${lateDate}","${earlyDate}")`, err);
                debugger;
            }
            return new TimeSpan(0);
        }
    }
    ms;
    earlyDate;
    lateDate;
    constructor(ms, lateDate, earlyDate) {
        this.ms = ms;
        this.lateDate = lateDate;
        this.earlyDate = earlyDate;
    }
    /**
     * całkowita liczba milisekund
     */
    get totalMiliseconds() {
        return this.ms;
    }
    /**
     * ilośc milisekund po odjęciu sekund, minut, godzin i dni
     */
    get miliseconds() {
        return this.ms % 1000;
    }
    /**
     * całkowita liczba sekund = liczba milisekund /1000
     */
    get totalSeconds() {
        return this.ms / 1000;
    }
    /**
     * liczba sekund po odjęciu minut, godzin i dni
     */
    get seconds() {
        // return this.ms % (1000 * 60);
        return Math.trunc((this.totalMinutes % 1) * 60);
    }
    /**
     * całkowita liczba minut
     */
    get totalMinutes() {
        return this.ms / 60000 /* 1000 * 60 */;
    }
    /**
     * liczba minut po odjęciu godzin i dni
     */
    get minutes() {
        return Math.trunc((this.totalHours % 1) * 60);
    }
    /**
     * całkowita liczba godzin
     */
    get totalHours() {
        return this.ms / 3600000 /* 1000 * 60 * 60 */;
    }
    /**
     * liczba godzn po odjęciu liczby dni
     */
    get hours() {
        return Math.trunc((this.totalDays % 1) * 24);
    }
    /**
     * całkowita liczba dni
     */
    get totalDays() {
        return this.ms / 86400000 /*1000 * 60 * 60 * 24*/;
    }
    /**
     * liczba dni, wartośc całkowita
     */
    get days() {
        return Math.trunc(this.totalDays);
    }
    /**
     * liczba miesięcy, wartośc całkowita
     */
    get months() {
        if (this.earlyDate && this.lateDate) {
            let res = (this.lateDate.getFullYear() - this.earlyDate.getFullYear()) * 12;
            res += this.lateDate.getMonth();
            res -= this.earlyDate.getMonth();
            if (res > 0) {
                if (this.lateDate.getDate() < this.earlyDate.getDate()) {
                    res--;
                }
            }
            else if (res < 0) {
                if (this.lateDate.getDate() > this.earlyDate.getDate()) {
                    res++;
                }
            }
            return res;
        }
        else {
            return Math.trunc(this.days / 30);
        }
    }
    /**
     * liczba lat, wartość całkowita
     */
    get years() {
        if (this.earlyDate && this.lateDate) {
            const date = new Date(this.ms);
            const years = Math.abs(date.getUTCFullYear() - 1970);
            if (this.lateDate < this.earlyDate) {
                return -years;
            }
            return years;
        }
        else {
            return Math.trunc(this.months / 12);
        }
    }
    /**
     * róznica w postaci HH:mm:ss
     */
    toString() {
        return ((0, numberFormatPad_1.numberFormatPad)(Math.trunc(this.totalHours), 2) +
            ':' +
            (0, numberFormatPad_1.numberFormatPad)(this.minutes, 2) +
            ':' +
            (0, numberFormatPad_1.numberFormatPad)(this.seconds, 2));
    }
}
exports.TimeSpan = TimeSpan;
//# sourceMappingURL=timeSpan.js.map